import Link from 'next/link'
import { StatusMessage } from '@/components/parts/status-message'

export const MailError = () => {
  return (
    <StatusMessage
      fillScreen
      illustSrc="/images/illust/contact/error01.svg"
      title="メールを送信できませんでした"
    >
      <p>
        なんらかの理由でメールを送信できませんでした。
        <br />
        もう一度お試しいただき、再び送信できない場合は
        <br />
        お手数ですが
        <Link href="/contact" className="text-ink-link hover:underline">
          こちら
        </Link>
        へお問い合わせください。
      </p>
    </StatusMessage>
  )
}
